// token
export const TOKEN = "token";
// token获取时间
export const TOKEN_TIME = "tokenTime";
// 刷新token
export const REFRESH_TOKEN = "refreshToken";

// 用户菜单角色
export const MENU_ROLE = "menu_role";
// tabs - 导航栏打开页签记录
export const TABS = "tabs";
// breadcrumb - 面包屑标签内容
export const BREAD_CRUMB = "bread_crumb";
// 用户菜单
export const USER_MENU = "user_menu";
// 用户选择进入的系统
export const USER_SYS_CODE = "user_sys_code";
// 用户姓名
export const USER_ID = "user_id";
export const USER_NAME = "user_name";
export const USER_LOGINNAME = "user_loginname";
// 用户主体名称
export const SUBJECT_NAME = "subject_name";
export const USER_ENT_ID = "user_ent_id";
export const USER_ORG_ID = "user_org_id";
export const USER_PLTF_ID = "user_pltf_id";
export const USER_MANAGE_ID = "user_management_id";
export const USER_ENT_NAME = "user_ent_name";
export const USER_ORG_NAME = "user_org_name";
export const USER_PLTF_NAME = "user_pltf_name";
export const USER_MANAGE_NAME = "user_manage_name";
export const USER_AUTHORITIES = "user_authorities";

// 字典类型
export const DICT_TYPE = "dict_type";
// 企业类型
export const ENT_TYPE = "ent_type";
// 企业注册类型
export const ECON_TYPE = "econ_type";
// 企业控股类型
export const CTRL_TYPE = "ctrl_type";
// 企业规模
export const ENT_SCALE = "ent_scale";
// 行业
export const INDUSTRY = "industry";
// 地区
export const DISTRICT = "district";
// 服务分类列表 8+1
export const SERVICE_CLASS = "service_list";
// 服务方式
export const SERVICE_MODE = "service_mode_list";
// 系统服务对象
export const SERVICE_OBJECT = "service_object_list";